import { Box, Button, Card, Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AccountService, SupportContactInfoDto } from "../api/psc";
import { Spinner } from "./exports";

export default function SuspiciousAccountPage() {
    const [contactInfo, setContactInfo] =
        useState<SupportContactInfoDto | null>(null);

    useEffect(() => {
        AccountService.getSupportContactInformation("1").then((r) => {
            setContactInfo(r);
        });
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100dvh",
                p: 2,
            }}
        >
            <Card
                sx={{
                    p: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    gap: 2,
                    maxWidth: 520,
                }}
            >
                <Typography color="warning.main" variant="h6">
                    حساب کاربری شما به صورت موقت در حال بررسی است
                </Typography>

                <Divider sx={{ width: "100%" }} />

                <Typography color="text.secondary">
                    دسترسی شما به پنل در حال حاضر محدود شده است. برای بررسی
                    وضعیت حساب و بازگردانی دسترسی، با پشتیبانی تماس بگیرید.
                </Typography>

                {!contactInfo && <Spinner />}

                {contactInfo && (
                    <Stack spacing={2} sx={{ width: "100%" }}>
                        <Typography color="text.secondary">
                            {contactInfo.notes}
                        </Typography>

                        <Divider textAlign="left">شماره های تماس</Divider>

                        <Stack direction="row" flexWrap="wrap" gap={1}>
                            {contactInfo.phoneNumbers.map((ph) => (
                                <a href={`tel:${ph}`} key={ph}>
                                    <Button variant="outlined">{ph}</Button>
                                </a>
                            ))}
                        </Stack>
                    </Stack>
                )}
            </Card>
        </Box>
    );
}
